module.exports = __webpack_public_path__ + "img/109-romania.136c0b83.svg";